import { render, staticRenderFns } from "./UnscheduledClassesReport.vue?vue&type=template&id=75e798b8&"
import script from "./UnscheduledClassesReport.vue?vue&type=script&lang=js&"
export * from "./UnscheduledClassesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports